
export default {
  // Navigation
  nav_home: "Home",
  nav_intro: "Introduction",
  nav_components: "Components",
  nav_operation: "Operation",
  nav_problems: "Problems",
  nav_diagnosis: "Diagnosis",
  nav_engineer: "Site Engineer",
  nav_safety: "Safety",
  nav_electrical: "Electrical Switching",
  nav_quiz1: "Quiz 1",
  nav_quiz2: "Quiz 2",
  nav_quiz3: "Quiz 3",
  nav_quiz_logistiek: "Logistics Quiz",

  // Home Page
  home_title: "Automated Logistics Systems",
  home_subtitle: "Professional training for BEUMER Group systems",
  home_welcome: "Welcome to the course",
  home_description: "This course covers automated logistics systems used at PostNL, DHL, Bol.com and airports. Learn about transport, sorting, barcode scanning and maintenance.",
  home_start: "Start the course",
  home_modules: "Course modules",
  home_quizzes: "Test your knowledge",

  // Introduction Page
  intro_title: "Introduction to Automated Logistics Systems",
  intro_description: "Automated logistics systems are used at PostNL, DHL, Bol.com and airports. These systems provide:",
  intro_feature1: "Package transport",
  intro_feature2: "Automatic sorting",
  intro_feature3: "Barcode reading",
  intro_feature4: "Distribution to the correct destination",
  intro_feature5: "Continuous monitoring",
  intro_beumer: "BEUMER Group designs, builds and maintains these systems.",

  // Components Page
  comp_title: "Main Components of a Logistics System",
  comp_conveyor: "Conveyor Belt",
  comp_conveyor_desc: "The conveyor belt automatically moves packages.",
  comp_conveyor_parts: "Important components:",
  comp_motor: "Motor",
  comp_inverter: "Inverter/drive",
  comp_rollers: "Rollers",
  comp_bearings: "Bearings",
  comp_belt: "Belt",
  comp_sensors: "Sensors",
  comp_safety: "Safety guards",
  comp_plc_control: "PLC control",
  
  comp_plc_title: "What is a PLC?",
  comp_plc_def: "A PLC (Programmable Logic Controller) is the computer that controls the entire system.",
  comp_plc_functions: "PLC functions:",
  comp_plc_func1: "Receives signals from sensors",
  comp_plc_func2: "Controls motors and actuators",
  comp_plc_func3: "Processes error codes",
  comp_plc_func4: "Regulates belt speed",
  comp_plc_func5: "Manages safety and emergency stops",
  comp_plc_func6: "Coordinates the complete sorting system",
  comp_plc_note: "Without a PLC, the system does not function.",

  comp_sensors_title: "Sensors",
  comp_sensors_desc: "Commonly used sensors:",
  comp_sensor1: "Photocell → detects package",
  comp_sensor2: "Proximity sensor → detects metal",
  comp_sensor3: "Barcode scanner → reads labels",
  comp_sensor4: "Laser scanner → measures size/position",
  comp_sensor5: "Emergency stop sensors",
  comp_sensors_note: "Sensors transmit information to the PLC.",

  comp_motors_title: "Motors & Drives",
  comp_motor_desc: "Motor: provides belt movement.",
  comp_drive_desc: "Drive (inverter): controls speed, direction and torque.",

  comp_mechanical_title: "Mechanical Components",
  comp_mech1: "Rollers",
  comp_mech2: "Bearings",
  comp_mech3: "Drive system",
  comp_mech4: "Belt tension",
  comp_mech5: "Guides",
  comp_mech6: "Frame and structure",
  comp_mech_note: "Mechanical wear is normal → regular maintenance is essential.",

  // Operation Page
  oper_title: "System Operation",
  oper_subtitle: "Step by step process",
  oper_step1: "Sensor detects a package",
  oper_step2: "PLC receives the signal",
  oper_step3: "Motor starts → belt moves",
  oper_step4: "Scanner reads barcode",
  oper_step5: "PLC determines the route",
  oper_step6: "Sorting mechanism directs package to the correct exit",
  oper_step7: "System monitors errors and safety",

  // Problems Page
  prob_title: "Common Problems and Solutions",
  prob_jammed: "Package Jammed",
  prob_jammed_cause: "Cause: package is crooked or physically stuck.",
  prob_jammed_solution: "Solution:",
  prob_jammed_sol1: "Stop machine safely",
  prob_jammed_sol2: "Remove package",
  prob_jammed_sol3: "Perform inspection",
  prob_jammed_sol4: "Restart system",

  prob_sensor: "Sensor Malfunction",
  prob_sensor_cause: "Cause: sensor dirty, displaced, cable loose.",
  prob_sensor_solution: "Solution:",
  prob_sensor_sol1: "Clean sensor",
  prob_sensor_sol2: "Secure cables",
  prob_sensor_sol3: "Align sensor correctly",
  prob_sensor_sol4: "Perform test on display",

  prob_mechanical: "Mechanical Failure",
  prob_mech_examples: "Examples:",
  prob_mech_ex1: "Belt too loose or crooked",
  prob_mech_ex2: "Roller defective",
  prob_mech_ex3: "Bearing worn",
  prob_mech_ex4: "Drive making noise",
  prob_mech_solution: "Solution:",
  prob_mech_sol1: "Check belt tension",
  prob_mech_sol2: "Replace rollers",
  prob_mech_sol3: "Lubricate or renew bearings",

  prob_electrical: "Electrical Failure",
  prob_elec_examples: "Examples:",
  prob_elec_ex1: "Fuse blown",
  prob_elec_ex2: "Cable break",
  prob_elec_ex3: "Motor without power",
  prob_elec_ex4: "Loose connections",
  prob_elec_solution: "Solution:",
  prob_elec_sol1: "Perform voltage measurement",
  prob_elec_sol2: "Check fuses",
  prob_elec_sol3: "Inspect cables and connectors",

  prob_plc: "PLC or Software Failure",
  prob_plc_examples: "Examples:",
  prob_plc_ex1: "Error code on PLC screen",
  prob_plc_ex2: "Sensor without signal",
  prob_plc_ex3: "Communication failures",
  prob_plc_solution: "Solution:",
  prob_plc_sol1: "Read error code",
  prob_plc_sol2: "Perform reset",
  prob_plc_sol3: "Check sensor/motor status",
  prob_plc_sol4: "Call service engineer if necessary",

  // Diagnosis Page
  diag_title: "Diagnosis Procedure",
  diag_subtitle: "Professional approach",
  diag_step1: "Stay calm",
  diag_step2: "Read error code on display",
  diag_step3: "Visual inspection",
  diag_step4: "Test sensors",
  diag_step5: "Check motor and belt",
  diag_step6: "Reset system safely",
  diag_step7: "Document the cause",
  diag_step8: "Take preventive action",

  // Engineer Page
  eng_title: "The Role of a Site Engineer",
  eng_description: "A Site Engineer is responsible for:",
  eng_resp1: "Process continuity",
  eng_resp2: "Troubleshooting",
  eng_resp3: "Preventive maintenance",
  eng_resp4: "Communication with operators",
  eng_resp5: "Executing safety procedures",
  eng_resp6: "Basic electrical and mechanical work",
  eng_resp7: "Shift work",
  eng_resp8: "Safe working (VCA)",
  eng_qualities: "Important qualities:",
  eng_qual1: "Calm",
  eng_qual2: "Accurate",
  eng_qual3: "Safety conscious",
  eng_qual4: "Problem-solving",
  eng_qual5: "Eager to learn",
  eng_qual6: "Collaborative",

  // Safety Page
  safety_title: "Safe Working",
  safety_subtitle: "Most important aspect",
  safety_description: "Safe working means:",
  safety_rule1: "Always disconnect power",
  safety_rule2: "\"Measure to be sure\": test voltage",
  safety_rule3: "Wear PPE",
  safety_rule4: "Apply Lock-out / Tag-out",
  safety_rule5: "Never work under pressure",
  safety_rule6: "Recognize risks",

  // Quiz Common
  quiz_submit: "Submit",
  quiz_retry: "Try again",
  quiz_score: "Your score:",
  quiz_correct: "correct out of",
  quiz_excellent: "Excellent! You have mastered the material well.",
  quiz_good: "Well done! You have the basics down.",
  quiz_review: "Review the course again and try once more.",

  // Quiz 1
  quiz1_title: "Quiz 1: Fundamentals",
  quiz1_q1: "What is the main function of an automated logistics system?",
  quiz1_q1_a: "Manually sort packages",
  quiz1_q1_b: "Automatic transport and sorting of packages",
  quiz1_q1_c: "Only scan barcodes",
  
  quiz1_q2: "Which companies use automated logistics systems?",
  quiz1_q2_a: "Only PostNL",
  quiz1_q2_b: "PostNL, DHL, Bol.com and airports",
  quiz1_q2_c: "Only airports",

  quiz1_q3: "What does BEUMER Group do?",
  quiz1_q3_a: "Only maintenance",
  quiz1_q3_b: "Design, build and maintain logistics systems",
  quiz1_q3_c: "Only develop software",

  quiz1_q4: "What is a conveyor belt?",
  quiz1_q4_a: "A manual cart",
  quiz1_q4_b: "A system that automatically moves packages",
  quiz1_q4_c: "A storage space",

  quiz1_q5: "What does PLC stand for?",
  quiz1_q5_a: "Package Logistics Center",
  quiz1_q5_b: "Programmable Logic Controller",
  quiz1_q5_c: "Post Delivery Computer",

  quiz1_q6: "What is the function of a PLC?",
  quiz1_q6_a: "Only weigh packages",
  quiz1_q6_b: "Control and coordinate the entire system",
  quiz1_q6_c: "Only print barcodes",

  quiz1_q7: "Which sensor detects a package on the belt?",
  quiz1_q7_a: "Temperature sensor",
  quiz1_q7_b: "Photocell",
  quiz1_q7_c: "Pressure sensor",

  quiz1_q8: "What does a barcode scanner read?",
  quiz1_q8_a: "Temperature",
  quiz1_q8_b: "Labels on packages",
  quiz1_q8_c: "Weight",

  // Quiz 2
  quiz2_title: "Quiz 2: Components and Operation",
  quiz2_q1: "What does a drive (inverter) control?",
  quiz2_q1_a: "Only the color of the belt",
  quiz2_q1_b: "Speed, direction and torque of the motor",
  quiz2_q1_c: "Only the temperature",

  quiz2_q2: "Which component provides belt movement?",
  quiz2_q2_a: "Sensor",
  quiz2_q2_b: "Motor",
  quiz2_q2_c: "PLC screen",

  quiz2_q3: "What is mechanical wear?",
  quiz2_q3_a: "A software error",
  quiz2_q3_b: "Normal wear of moving parts requiring regular maintenance",
  quiz2_q3_c: "An electrical failure",

  quiz2_q4: "What is the first step in system operation?",
  quiz2_q4_a: "Motor starts",
  quiz2_q4_b: "Sensor detects a package",
  quiz2_q4_c: "Barcode is printed",

  quiz2_q5: "What happens after the scanner reads the barcode?",
  quiz2_q5_a: "The system stops",
  quiz2_q5_b: "PLC determines the route",
  quiz2_q5_c: "The package is weighed",

  quiz2_q6: "What does the sorting mechanism do?",
  quiz2_q6_a: "Weigh packages",
  quiz2_q6_b: "Direct packages to the correct exit",
  quiz2_q6_c: "Print barcodes",

  quiz2_q7: "What information do sensors transmit?",
  quiz2_q7_a: "Only temperature",
  quiz2_q7_b: "Signals to the PLC",
  quiz2_q7_c: "Only weight",

  quiz2_q8: "What does the system continuously monitor?",
  quiz2_q8_a: "Only the time",
  quiz2_q8_b: "Errors and safety",
  quiz2_q8_c: "Only the color of packages",

  // Quiz 3
  quiz3_title: "Quiz 3: Practice and Safety",
  quiz3_q1: "What is the first step with a jammed package?",
  quiz3_q1_a: "Pull the package out forcefully",
  quiz3_q1_b: "Stop the machine safely",
  quiz3_q1_c: "Continue working",

  quiz3_q2: "What can cause a sensor malfunction?",
  quiz3_q2_a: "Too many packages",
  quiz3_q2_b: "Sensor dirty, displaced or cable loose",
  quiz3_q2_c: "Not enough light in the room",

  quiz3_q3: "What is an example of mechanical failure?",
  quiz3_q3_a: "Error code on screen",
  quiz3_q3_b: "Belt too loose or crooked",
  quiz3_q3_c: "Internet connection lost",

  quiz3_q4: "What should you do with a blown fuse?",
  quiz3_q4_a: "Ignore and continue working",
  quiz3_q4_b: "Check and replace fuse",
  quiz3_q4_c: "Restart system without checking",

  quiz3_q5: "What is the first step in the diagnosis procedure?",
  quiz3_q5_a: "Panic",
  quiz3_q5_b: "Stay calm",
  quiz3_q5_c: "Immediately call the engineer",

  quiz3_q6: "What does a Site Engineer do?",
  quiz3_q6_a: "Only get coffee",
  quiz3_q6_b: "Troubleshoot and perform preventive maintenance",
  quiz3_q6_c: "Only administration",

  quiz3_q7: "Which quality is important for a Site Engineer?",
  quiz3_q7_a: "Impatient",
  quiz3_q7_b: "Safety conscious",
  quiz3_q7_c: "Inaccurate",

  quiz3_q8: "What does 'Measure to be sure' mean?",
  quiz3_q8_a: "Always use a tape measure",
  quiz3_q8_b: "Test voltage before working",
  quiz3_q8_c: "Weigh packages",

  quiz3_q9: "What is Lock-out / Tag-out?",
  quiz3_q9_a: "Locking the door",
  quiz3_q9_b: "Safety procedure to disconnect and mark power",
  quiz3_q9_c: "A computer program",

  quiz3_q10: "Why is safe working the most important aspect?",
  quiz3_q10_a: "To work faster",
  quiz3_q10_b: "To prevent accidents and injuries",
  quiz3_q10_c: "To take fewer breaks",

  // Electrical Switching Page
  elec_title: "Electrical Switching",
  elec_subtitle: "Professional guide for technical personnel, mechanics and Site Engineers",

  // 1. What is electrical switching
  elec_what_title: "1. What is Electrical Switching?",
  elec_what_desc: "Electrical switching is the opening and closing of electrical circuits to control power supply. This is a fundamental principle in all electrical and automated systems.",
  elec_examples: "Examples of switching:",
  elec_ex1: "Light switch",
  elec_ex2: "Relay",
  elec_ex3: "Contactor",
  elec_ex4: "PLC output",
  elec_ex5: "Emergency stop button",
  elec_ex6: "Start/Stop buttons",
  elec_closed: "Closed Circuit",
  elec_closed_desc: "Current can flow → device works",
  elec_open: "Open Circuit",
  elec_open_desc: "No current → device is off",

  // 2. Basic concepts
  elec_basics_title: "2. Basic Switching Concepts",
  elec_series: "Series Circuit",
  elec_series_desc: "All switches must be closed for current to flow. If one switch is open, the circuit does not work.",
  elec_parallel: "Parallel Circuit",
  elec_parallel_desc: "If one of the switches is closed, current can flow. Multiple routes possible.",
  elec_no: "NO (Normally Open)",
  elec_no_desc: "Normally open contact. Closes only when activated (e.g., button pressed).",
  elec_nc: "NC (Normally Closed)",
  elec_nc_desc: "Normally closed contact. Opens only when activated. Often used for safety.",

  // 3. Types of switches
  elec_types_title: "3. Types of Switches",
  elec_type1: "Single-pole Switch",
  elec_type1_desc: "Switches one circuit on or off. Used for simple applications like lighting.",
  elec_type2: "Double-pole Switch",
  elec_type2_desc: "Switches two circuits simultaneously. Used for 230V applications where phase and neutral are switched.",
  elec_type3: "Push Button (NO/NC)",
  elec_type3_desc: "Temporary switch that springs back. Available as NO (normally open) or NC (normally closed).",
  elec_type4: "Magnetic Switch / Contactor",
  elec_type4_desc: "Electromagnetic switch for heavy currents. Used for motors and large loads.",
  elec_type5: "Relay",
  elec_type5_desc: "Small electromagnetic switch. Low current controls high current.",
  elec_type6: "PLC Outputs",
  elec_type6_desc: "Digital outputs from the PLC that control other devices via relays or transistors.",
  elec_type7: "Limit Switches",
  elec_type7_desc: "Detect position of moving parts. Often used as safety limits.",
  elec_type8: "Safety Relays",
  elec_type8_desc: "Special relays for safety circuits with forced contact separation.",

  // 4. Industrial systems
  elec_industrial_title: "4. Electrical Switching in Industrial Systems",
  elec_industrial_desc: "In logistics systems like BEUMER Group, electrical switching is used for:",
  elec_ind1: "Motor Control",
  elec_ind1_desc: "Contactors switch motors for conveyor belts on and off. The PLC controls the contactor.",
  elec_ind2: "Start/Stop Circuits",
  elec_ind2_desc: "Push buttons for manual operation. Start button (NO) and Stop button (NC) in series with safety chain.",
  elec_ind3: "Sensor Circuits",
  elec_ind3_desc: "Sensors switch signals to the PLC. Photocells, proximity sensors and scanners.",
  elec_ind4: "Safety Chains",
  elec_ind4_desc: "NC contacts connected in series. If one safety switch opens, the entire system stops.",
  elec_ind5: "Emergency Stop Wiring",
  elec_ind5_desc: "Emergency stops are NC contacts in the safety chain. Pressing opens the contact and stops the machine.",
  elec_ind6: "Fault Detection via PLC",
  elec_ind6_desc: "PLC monitors all circuits and detects faults such as sensor failure or motor overload.",
  elec_beumer_title: "BEUMER Group Systems",
  elec_beumer_desc: "At BEUMER Group, complex circuit diagrams are used to control conveyor belts, sorting systems and safety chains. Site Engineers must be able to read these diagrams and troubleshoot.",

  // 5. Safety
  elec_safety_title: "5. Safe Electrical Switching (VCA Level)",
  elec_safety_warning: "⚠️ WARNING: Electricity is life-threatening! Always follow safety rules.",
  elec_safe1: "Always Disconnect Power",
  elec_safe1_desc: "Turn off the main switch before working on electrical installations. Check all phases.",
  elec_safe2: "Measure to be Sure",
  elec_safe2_desc: "Always test with a multimeter or voltage tester if the power is really off. Don't trust switches alone.",
  elec_safe3: "Lock-out / Tag-out",
  elec_safe3_desc: "Lock the main switch with a padlock and hang a warning label. Only you have the key.",
  elec_safe4: "Wear PPE",
  elec_safe4_desc: "Wear personal protective equipment: safety shoes, gloves, safety glasses and insulated tools.",
  elec_safe5: "Never Bypass Emergency Stops",
  elec_safe5_desc: "Bypassing emergency stops or safety switches is life-threatening and strictly prohibited.",
  elec_safe6: "Recognize Risks",
  elec_safe6_desc: "Watch for damaged cables, loose connections, moisture and other hazards. Report dangerous situations immediately.",

  // 6. Common errors
  elec_errors_title: "6. Common Errors and Solutions",
  elec_error: "ERROR",
  elec_solution: "SOLUTION",
  elec_err1: "Loose Terminals",
  elec_err1_sol: "Check all terminals with a screwdriver. Tighten loose terminals. Check for oxidation.",
  elec_err2: "Incorrect NO/NC Connection",
  elec_err2_sol: "Check the circuit diagram. Measure with multimeter which contact is NO and NC. Connect correctly.",
  elec_err3: "Blown Fuse",
  elec_err3_sol: "First find the cause (short circuit, overload). Fix the problem. Replace fuse with correct value.",
  elec_err4: "Cable Break",
  elec_err4_sol: "Measure continuity with multimeter. Replace damaged cable. Check cable routing for sharp edges.",
  elec_err5: "Sensor Not Working",
  elec_err5_sol: "Clean the sensor. Check supply voltage. Test with PLC display. Check distance and alignment.",
  elec_err6: "Contactor Not Engaging",
  elec_err6_sol: "Measure coil voltage. Check PLC output. Clean contacts. Replace defective contactor.",

  // 7. Practice exercises
  elec_practice_title: "7. Practical Exercises",
  elec_practice_desc: "Test your knowledge with these practical questions:",
  elec_q1: "What happens if an NC sensor remains open?",
  elec_q1_a: "The system starts automatically",
  elec_q1_b: "The system cannot start (safety chain interrupted)",
  elec_q1_c: "Nothing, the system works normally",
  elec_q2: "What do you check first when a motor does not start?",
  elec_q2_a: "The color of the motor",
  elec_q2_b: "Whether the motor is new",
  elec_q2_c: "Voltage on contactor, PLC output, emergency stop position and fuses",
  elec_q3: "Why is a contactor used instead of a regular switch?",
  elec_q3_a: "A contactor can switch high currents and is remotely controlled",
  elec_q3_b: "A contactor is cheaper",
  elec_q3_c: "A contactor looks nicer",
  elec_check: "Check Answers",
  elec_retry: "Try Again",
  elec_perfect: "Perfect! All answers correct!",
  elec_good: "Well done!",
  elec_try_again: "Try again",
  elec_score_text: "You answered {score} out of {total} questions correctly.",

  // 8. Summary
  elec_summary_title: "8. Summary",
  elec_sum1: "Electrical switching is opening and closing circuits to control current",
  elec_sum2: "NO (Normally Open) closes when activated, NC (Normally Closed) opens when activated",
  elec_sum3: "Series circuit: all switches must be closed. Parallel circuit: one closed switch is enough",
  elec_sum4: "Different switches: single-pole, double-pole, push buttons, contactors, relays, PLC outputs",
  elec_sum5: "In industrial systems, circuits are used for motors, sensors, safety and emergency stops",
  elec_sum6: "Safety is paramount: disconnect power, measure, Lock-out/Tag-out, wear PPE",
  elec_sum7: "Common errors: loose terminals, incorrect connections, blown fuses, cable breaks",
  elec_sum8: "As a Site Engineer, you must be able to read circuit diagrams and troubleshoot electrical faults",
  elec_final_message: "Electrical switching is a fundamental skill for every Site Engineer. Safety always comes first!",

  // Onderhoudstechniek page
  maint_title: 'Maintenance Technology',
  maint_subtitle: 'Professional techniques for maintaining logistics systems, machines and installations',
  
  maint_what_title: 'What is maintenance technology?',
  maint_what_desc: 'Maintenance technology is an essential field focused on keeping machines, installations and technical systems in optimal condition. The goal is to prevent failures, improve reliability and ensure safety.',
  
  maint_focus1: 'Maintaining machines',
  maint_focus1_desc: 'Regular maintenance on conveyor belts, motors, bearings and other mechanical components',
  maint_focus2: 'Preventing failures',
  maint_focus2_desc: 'Proactive action to prevent defects before they occur',
  maint_focus3: 'Improving reliability',
  maint_focus3_desc: 'Optimizing systems for maximum uptime and performance',
  maint_focus4: 'Safe working',
  maint_focus4_desc: 'Performing all work according to VCA standards and safety protocols',
  
  maint_logistics_title: 'Examples from logistics systems',
  maint_logistics_desc: 'In sorting centers of PostNL, DHL and Bol.com, maintenance technology is crucial. Conveyor belts must process thousands of packages daily. Preventive maintenance on bearings, rollers and sensors prevents costly downtime and ensures continuous operation.',
  
  maint_types_title: 'Types of maintenance',
  
  maint_preventive: 'Preventive maintenance',
  maint_preventive_desc: 'Planned maintenance to prevent failures',
  maint_prev1: 'Scheduled maintenance according to plan',
  maint_prev2: 'Lubricating bearings and moving parts',
  maint_prev3: 'Replacing wear parts',
  maint_prev4: 'Periodic inspections and checks',
  
  maint_corrective: 'Corrective maintenance',
  maint_corrective_desc: 'Repairs after a failure or defect',
  maint_corr1: 'Repairs after failures',
  maint_corr2: 'Replacing defective parts',
  maint_corr3: 'Performing diagnosis and solving',
  
  maint_predictive: 'Predictive maintenance',
  maint_predictive_desc: 'Maintenance based on sensor data and analysis',
  maint_pred1: 'Analyzing sensor data',
  maint_pred2: 'Performing vibration measurements',
  maint_pred3: 'Monitoring temperature measurements',
  maint_pred4: 'Early fault detection',
  
  maint_periodic: 'Periodic maintenance',
  maint_periodic_desc: 'Regular checks according to fixed schedule',
  maint_per1: 'Weekly checks',
  maint_per2: 'Monthly inspections',
  maint_per3: 'Annual major maintenance',
  
  maint_components_title: 'Important components in maintenance technology',
  
  maint_comp1: 'Motors (AC/DC)',
  maint_comp1_desc: 'Electric drives for conveyor belts and machines',
  maint_comp2: 'Bearings',
  maint_comp2_desc: 'Ball bearings and roller bearings supporting moving parts',
  maint_comp3: 'Rollers',
  maint_comp3_desc: 'Transport rollers for belt transport',
  maint_comp4: 'Conveyor belts',
  maint_comp4_desc: 'Rubber or plastic belts for goods transport',
  maint_comp5: 'Drives (inverters)',
  maint_comp5_desc: 'Frequency controllers for motor control',
  maint_comp6: 'Sensors',
  maint_comp6_desc: 'Photo-electric, inductive and laser sensors',
  maint_comp7: 'Chains and gears',
  maint_comp7_desc: 'Mechanical transmissions and couplings',
  maint_comp8: 'Electrical wiring',
  maint_comp8_desc: 'Cables, switch cabinets and connections',
  
  maint_diagnosis_title: 'Diagnosis and fault analysis',
  maint_diagnosis_desc: 'A systematic approach to detecting and solving failures:',
  
  maint_diag1: 'Reading error codes',
  maint_diag1_desc: 'Check PLC error codes and alarm messages',
  maint_diag2: 'Visual inspection',
  maint_diag2_desc: 'Check for visible damage, wear or deviations',
  maint_diag3: 'Performing measurements',
  maint_diag3_desc: 'Measure voltage, resistance and continuity with multimeter',
  maint_diag4: 'Testing sensors',
  maint_diag4_desc: 'Check sensor operation and measure signals',
  maint_diag5: 'Checking motors',
  maint_diag5_desc: 'Assess vibrations, temperature and sound of motors',
  maint_diag6: 'Disassembling parts',
  maint_diag6_desc: 'Remove and inspect suspicious components',
  maint_diag7: 'Registering cause',
  maint_diag7_desc: 'Document failure in maintenance log',
  maint_diag8: 'Preventive measures',
  maint_diag8_desc: 'Take actions to prevent recurrence',
  
  maint_procedures_title: 'Maintenance procedures',
  
  maint_proc1: 'Safe shutdown (LOTO)',
  maint_proc1_desc: 'Apply Lock-out/Tag-out procedure',
  maint_proc2: 'Voltage-free working',
  maint_proc2_desc: 'Switch off voltage and verify',
  maint_proc3: 'Lubricating bearings',
  maint_proc3_desc: 'Apply correct lubricants in correct places',
  maint_proc4: 'Replacing conveyor belts',
  maint_proc4_desc: 'Remove old belt and install new belt',
  maint_proc5: 'Aligning motors',
  maint_proc5_desc: 'Position motors and rollers correctly',
  maint_proc6: 'Tensioning chains',
  maint_proc6_desc: 'Set correct tension of chains and belts',
  maint_proc7: 'Cleaning and inspection',
  maint_proc7_desc: 'Clean and check machines',
  maint_proc8: 'Performing checks',
  maint_proc8_desc: 'Pre and post checks according to checklist',
  
  maint_safety_title: 'Safety during maintenance (VCA)',
  maint_safety_warning: 'Safety always has priority!',
  maint_safety_warning_desc: 'All maintenance work must be performed according to VCA standards and company safety protocols. Never take risks and always work according to procedures.',
  
  maint_safe1: 'Switch off voltage',
  maint_safe1_desc: 'Always switch off voltage first before starting',
  maint_safe2: 'Lock-out/Tag-out',
  maint_safe2_desc: 'Apply and lock LOTO procedure',
  maint_safe3: 'Wear PPE',
  maint_safe3_desc: 'Helmet, safety glasses, gloves and shoes',
  maint_safe4: 'Assess risks',
  maint_safe4_desc: 'Perform workplace inspection and risk analysis',
  maint_safe5: 'Correct tools',
  maint_safe5_desc: 'Only use approved and suitable tools',
  maint_safe6: 'Fire safety',
  maint_safe6_desc: 'Fire extinguisher available and escape routes clear',
  maint_safe7: 'Machine protection',
  maint_safe7_desc: 'Respect protections and do not remove',
  maint_safe8: 'No bypasses',
  maint_safe8_desc: 'Never bypass safety circuits',
  
  maint_problems_title: 'Common problems and solutions',
  
  maint_prob1: 'Worn bearings',
  maint_prob1_sol: 'Replace bearings, investigate cause of wear (lubrication, load)',
  maint_prob2: 'Misaligned conveyor belt',
  maint_prob2_sol: 'Align rollers, check and adjust belt tension',
  maint_prob3: 'Defective sensor',
  maint_prob3_sol: 'Clean sensor, check adjustment or replace sensor',
  maint_prob4: 'Cable break',
  maint_prob4_sol: 'Replace damaged cable, check fastening',
  maint_prob5: 'Overheated motor',
  maint_prob5_sol: 'Check cooling, reduce load, replace motor if necessary',
  maint_prob6: 'Loose terminals',
  maint_prob6_sol: 'Check and tighten all electrical connections',
  maint_prob7: 'Contamination in machine',
  maint_prob7_sol: 'Thoroughly clean machine, establish preventive cleaning schedule',
  maint_prob8: 'Broken rollers',
  maint_prob8_sol: 'Replace defective rollers, investigate cause of breakage',
  maint_prob9: 'Defective inverter',
  maint_prob9_sol: 'Read error codes, check parameters or replace inverter',
  
  maint_problem: 'Problem',
  maint_solution: 'Solution',
  maint_cause: 'Cause',
  
  maint_cases_title: 'Practical examples',
  maint_cases_desc: 'Real situations from practice with diagnosis and solutions:',
  maint_click_details: 'Click for details',
  
  maint_case1_title: 'Motor does not start',
  maint_case1_problem: 'A conveyor belt motor does not respond to the start signal. The PLC gives no error message.',
  maint_case1_cause: 'After checking, the motor protection (thermal relay) was switched off due to overload. The conveyor belt was overloaded with too heavy packages.',
  maint_case1_solution: 'Reset thermal relay, check load and set maximum load. Preventive: communicate and monitor weight limit.',
  
  maint_case2_title: 'Conveyor belt runs crooked',
  maint_case2_problem: 'The conveyor belt keeps running to one side and threatens to run off the rollers.',
  maint_case2_cause: 'The rollers are not mounted parallel and the belt tension is unequal.',
  maint_case2_solution: 'Align rollers with spirit level and laser alignment equipment. Set belt tension evenly on both sides. Center belt and perform test run.',
  
  maint_case3_title: 'Sensor gives no signal',
  maint_case3_problem: 'A photo-electric sensor no longer detects packages. The LED on the sensor does not light up.',
  maint_case3_cause: 'The sensor lens is contaminated by dust and the sensor is no longer sensitive enough.',
  maint_case3_solution: 'Clean sensor with suitable cleaning agents. Check detection distance and reset. Establish preventive cleaning schedule.',
  
  maint_case4_title: 'PLC failure: no output',
  maint_case4_problem: 'A PLC output no longer activates a motor. The PLC indicator does light up.',
  maint_case4_cause: 'The output module is defective due to a short circuit in the wiring.',
  maint_case4_solution: 'Locate and repair short circuit in wiring. Replace defective output module. Check wiring for damage and insulation.',
  
  maint_summary_title: 'Summary',
  
  maint_sum1: 'Maintenance technology is essential for reliable and safe operation of logistics systems',
  maint_sum2: 'There are four main types of maintenance: preventive, corrective, predictive and periodic',
  maint_sum3: 'Systematic diagnosis helps solve failures quickly and effectively',
  maint_sum4: 'Safety according to VCA standards always has absolute priority',
  maint_sum5: 'Knowledge of components and procedures is crucial for professional maintenance',
  maint_sum6: 'Good documentation and preventive measures prevent recurrence of problems',
  
  maint_final_message: 'Professional maintenance ensures maximum uptime, safety and efficiency in logistics operations!',

  // Quiz Logistiek
  quiz_logistiek_title: "Quiz – Logistics Automation & Site Engineer",
  quiz_logistiek_intro: "Test your knowledge of automated logistics systems, PLCs, sensors, troubleshooting, and the role of a Site Engineer. This comprehensive quiz contains 30 questions covering all aspects of modern logistics automation.",
  quiz_logistiek_instructions: "Answer all 30 questions by selecting the correct answer (A, B, or C). You will receive immediate feedback on your score.",
  
  // Quiz Logistiek Questions
  quiz_logistiek_q1: "What is the main function of a PLC in logistics automation?",
  quiz_logistiek_q1_a: "Only controlling lighting",
  quiz_logistiek_q1_b: "Reading sensors and controlling motors/actuators",
  quiz_logistiek_q1_c: "Cleaning the conveyor belt",

  quiz_logistiek_q2: "Which company does NOT use automated sorting systems?",
  quiz_logistiek_q2_a: "A small bakery",
  quiz_logistiek_q2_b: "PostNL",
  quiz_logistiek_q2_c: "DHL",

  quiz_logistiek_q3: "What happens when a photocell (sensor) is dirty?",
  quiz_logistiek_q3_a: "The motor runs faster",
  quiz_logistiek_q3_b: "Nothing changes",
  quiz_logistiek_q3_c: "Packages are not detected",

  quiz_logistiek_q4: "Which component provides the drive for a conveyor belt?",
  quiz_logistiek_q4_a: "Only the rollers",
  quiz_logistiek_q4_b: "Motor with gearbox",
  quiz_logistiek_q4_c: "Only the belt itself",

  quiz_logistiek_q5: "What does 'preventive maintenance' mean?",
  quiz_logistiek_q5_a: "Performing maintenance before a failure occurs",
  quiz_logistiek_q5_b: "Only repairing after a breakdown",
  quiz_logistiek_q5_c: "Never maintaining the machine",

  quiz_logistiek_q6: "Which safety procedure must you ALWAYS apply before maintenance?",
  quiz_logistiek_q6_a: "Only wearing gloves",
  quiz_logistiek_q6_b: "Just start working",
  quiz_logistiek_q6_c: "Lock-out/Tag-out (LOTO) procedure",

  quiz_logistiek_q7: "What is a proximity sensor?",
  quiz_logistiek_q7_a: "A sensor that makes sound",
  quiz_logistiek_q7_b: "A sensor that detects metal objects without contact",
  quiz_logistiek_q7_c: "A sensor that only detects light",

  quiz_logistiek_q8: "Which voltage must you switch off FIRST during electrical maintenance?",
  quiz_logistiek_q8_a: "The main voltage (400V)",
  quiz_logistiek_q8_b: "Only the control voltage (24V)",
  quiz_logistiek_q8_c: "No voltage needs to be switched off",

  quiz_logistiek_q9: "What is the function of bearings in a conveyor belt?",
  quiz_logistiek_q9_a: "Heating the belt",
  quiz_logistiek_q9_b: "Making noise",
  quiz_logistiek_q9_c: "Allowing rollers to rotate smoothly with minimal friction",

  quiz_logistiek_q10: "How do you recognize a defective motor?",
  quiz_logistiek_q10_a: "Motor is cold",
  quiz_logistiek_q10_b: "Abnormal sounds, overheating, or failure to start",
  quiz_logistiek_q10_c: "Motor runs too slowly",

  quiz_logistiek_q11: "What is corrective maintenance?",
  quiz_logistiek_q11_a: "Performing repairs after a failure has occurred",
  quiz_logistiek_q11_b: "Only cleaning",
  quiz_logistiek_q11_c: "Preventive lubrication",

  quiz_logistiek_q12: "Which PPE (Personal Protective Equipment) is mandatory in a logistics center?",
  quiz_logistiek_q12_a: "Only gloves",
  quiz_logistiek_q12_b: "Only safety shoes",
  quiz_logistiek_q12_c: "Safety shoes, helmet, safety glasses, and gloves",

  quiz_logistiek_q13: "What does an NO (Normally Open) contact mean?",
  quiz_logistiek_q13_a: "Contact is always closed",
  quiz_logistiek_q13_b: "Contact is open at rest, closes when activated",
  quiz_logistiek_q13_c: "Contact doesn't work",

  quiz_logistiek_q14: "What is the first step when diagnosing a fault?",
  quiz_logistiek_q14_a: "Reading fault codes and performing visual inspection",
  quiz_logistiek_q14_b: "Directly replacing components",
  quiz_logistiek_q14_c: "Restarting the machine",

  quiz_logistiek_q15: "What is the function of a barcode scanner in logistics?",
  quiz_logistiek_q15_a: "Weighing packages",
  quiz_logistiek_q15_b: "Measuring temperature",
  quiz_logistiek_q15_c: "Reading package information for sorting and tracking",

  quiz_logistiek_q16: "How often should you lubricate bearings?",
  quiz_logistiek_q16_a: "Never",
  quiz_logistiek_q16_b: "According to maintenance schedule (e.g., monthly)",
  quiz_logistiek_q16_c: "Only when they break",

  quiz_logistiek_q17: "What is the main task of a Site Engineer?",
  quiz_logistiek_q17_a: "Solving faults, monitoring processes, and coordinating communication",
  quiz_logistiek_q17_b: "Only drinking coffee",
  quiz_logistiek_q17_c: "Only doing administration",

  quiz_logistiek_q18: "Which measurement do you perform to find a cable break?",
  quiz_logistiek_q18_a: "Temperature measurement",
  quiz_logistiek_q18_b: "Weight measurement",
  quiz_logistiek_q18_c: "Continuity measurement",

  quiz_logistiek_q19: "What is an inverter (frequency drive)?",
  quiz_logistiek_q19_a: "A switch",
  quiz_logistiek_q19_b: "A device that controls motor speed by adjusting frequency",
  quiz_logistiek_q19_c: "A lamp",

  quiz_logistiek_q20: "Which procedure do you follow when an emergency stop is activated?",
  quiz_logistiek_q20_a: "Check cause, ensure safety, then perform reset",
  quiz_logistiek_q20_b: "Reset immediately without checking",
  quiz_logistiek_q20_c: "Ignore the emergency stop",

  quiz_logistiek_q21: "What is predictive maintenance?",
  quiz_logistiek_q21_a: "Guessing when maintenance is needed",
  quiz_logistiek_q21_b: "Only visual inspection",
  quiz_logistiek_q21_c: "Planning maintenance based on sensor data and measurements",

  quiz_logistiek_q22: "How do you test if a sensor works?",
  quiz_logistiek_q22_a: "Only looking at it",
  quiz_logistiek_q22_b: "Measuring signal with multimeter or checking PLC status",
  quiz_logistiek_q22_c: "Replacing the sensor",

  quiz_logistiek_q23: "What usually causes a misaligned conveyor belt?",
  quiz_logistiek_q23_a: "Incorrectly aligned rollers or uneven tension",
  quiz_logistiek_q23_b: "Too many packages",
  quiz_logistiek_q23_c: "Wrong belt color",

  quiz_logistiek_q24: "What information do you find in a PLC fault code?",
  quiz_logistiek_q24_a: "Only the time",
  quiz_logistiek_q24_b: "Only the date",
  quiz_logistiek_q24_c: "Type of fault, location, and possible cause",

  quiz_logistiek_q25: "What is the function of a contactor?",
  quiz_logistiek_q25_a: "Making noise",
  quiz_logistiek_q25_b: "Switching electrical circuits (on/off) remotely",
  quiz_logistiek_q25_c: "Only dimming lights",

  quiz_logistiek_q26: "How do you prevent packages from jamming on a conveyor belt?",
  quiz_logistiek_q26_a: "Regular inspection, proper adjustment, and keeping clean",
  quiz_logistiek_q26_b: "Pushing harder",
  quiz_logistiek_q26_c: "Putting more packages on it",

  quiz_logistiek_q27: "What does NC (Normally Closed) contact mean?",
  quiz_logistiek_q27_a: "Contact doesn't work",
  quiz_logistiek_q27_b: "Contact is always open",
  quiz_logistiek_q27_c: "Contact is closed at rest, opens when activated",

  quiz_logistiek_q28: "Which check do you perform after replacing a conveyor belt?",
  quiz_logistiek_q28_a: "Check nothing",
  quiz_logistiek_q28_b: "Check alignment, tension, and test run",
  quiz_logistiek_q28_c: "Only check the color",

  quiz_logistiek_q29: "What is the most important rule during shift work as a Site Engineer?",
  quiz_logistiek_q29_a: "Good handover of information between shifts",
  quiz_logistiek_q29_b: "Going home as quickly as possible",
  quiz_logistiek_q29_c: "Only doing your own work",

  quiz_logistiek_q30: "Which measurement do you perform to diagnose motor problems?",
  quiz_logistiek_q30_a: "Only looking at the motor",
  quiz_logistiek_q30_b: "Smelling the motor",
  quiz_logistiek_q30_c: "Measuring voltage, current, and insulation resistance",

  // Quiz feedback
  quiz_progress: "Progress",
  quiz_questions: "questions",
  quiz_expert_level: "Expert Level Achieved!",
  quiz_expert_message: "Excellent! You have very good knowledge of logistics automation and Site Engineer tasks.",
  quiz_average: "Average - more study recommended",
};
